import { SelectableListKeyboardNavigationGroupHorizontal } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";

interface Props {
  onClick: () => void
}

const RemovableLabel = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className="removable-label gap-small">
      <div>{props.children}</div>
      <div className="removable-label-icon" onClick={props.onClick}>
        {props.onClick && <i
          {...SelectableListKeyboardNavigationGroupHorizontal("removableLabel")}
          tabIndex={0}
          className="icon icon-x tiny"
        />}
      </div>
    </div>
  );
};

export default RemovableLabel;